import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';
import NotFoundComponent from '@/components/NotFound';
import SystemSevice from '@/services/System';
import admin from '@/router/admin.js';
import portal from '@/router/public.js';
import auth from '@/router/auth.js';
import expert from '@/router/expert.js';

Vue.use(VueRouter);

const routes = [
  ...auth,
  ...admin,
  ...expert,
  ...portal,
  {
    path: '*',
    component: NotFoundComponent,
    name: 'NotFound'
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0);

  // write site view
  SystemSevice.setSiteViewLocal(to);

  // check exist user data
  const userInfo = localStorage.getItem('user');
  if (userInfo) {
    const userData = JSON.parse(userInfo);
    const now = Math.floor(Date.now() / 1000);
    if (userData && (!userData.expires_in || now > userData.expires_in) ) {
      
      store.dispatch('openSnackbar', {
        text: 'Hết phiên làm việc! Vui lòng đăng nhập lại.', 
        type: 'warning'
      });

      setTimeout(function(){
        store.dispatch('logout');
      }, 1000);

      return null;
    }
    store.commit('setUserData', userData);
  }

  //init state
  store.state.showHeaderSlider=false;

  //set title
  let title = store.state.config.sysTitle;
  if(to.meta.title) {
    title = `${to.meta.title} | ${title}`;
  }
  document.title = title;

  // permission require
  if ( to.meta.can ) {
    let Permission = store.state.authMod.user.user.permission;
    if (typeof Permission != 'undefined') {
      if(Permission.indexOf(to.meta.can) == -1){
        next({ name: 'Home' });
      }
    }
  }

  // change favicon
  // const favicon = document.getElementById("favicon");
  // if(to.matched.some(record => record.meta.requiresAuth)) {
  //   favicon.href = "/favicon_admin.ico";
  // } else {
  //   favicon.href = "/favicon.ico";
  // }
  
  if (to.matched.some(record => record.meta.requiresAuth) && !userInfo) {
    next({ name: 'Login' });
  } else if(to.matched.some(record => record.meta.disableIfLoggedIn) && userInfo){
    next({ name: 'Dashboard' });
  } else {
    // role admin site
    if( to.matched.some(record => record.meta.isAdmin) ){
      let Role = store.state.authMod.user.user.role;
      if(Role.indexOf('supper-admin') == -1 
        &&  Role.indexOf('so-nong-nghiep') == -1
        &&  Role.indexOf('ql-chat-luong') == -1
      ){
        next({ name: 'Home' });
      }
      next();
    }
    // role expert site
    if( to.matched.some(record => record.meta.isChuyenGia)){
      let Role = store.state.authMod.user.user.role;
      if(Role.indexOf('chuyen-gia') == -1){
        next({ name: 'Home' });
      }
      next();
    }
    next();
  }
});

export default router;
